<mg-mm-districts-table></mg-mm-districts-table>
